import React from 'react'
import Matter, { Body, Events } from 'matter-js'
import {animate } from './Animation.js'
import './Animation.js'
import './Parallax'
import { bacgrkoundparallax } from './Parallax.js'
import { GetHighScore, SetHighScore } from '../Firebase.js'
import musicFile from '../../assets/music/RunBoysRunTotallyNotCopiedMusic.mp3'
import deathSound from '../../assets/music/deathSound.mp3'
let music =  new Audio(musicFile)
music.volume = 0.3;

let airState = ""
let isGrounded = true
let gameSpeed = 3
let ground1;
let ground2;
let ground3;
let isGameOver = false

class Game extends React.Component{
  constructor(props){
    super(props)
    this.state = {}
  }

  componentDidMount(){
    document.querySelector('nav').style.display = 'none'
    var Engine = Matter.Engine,
        Render = Matter.Render,
        Runner = Matter.Runner,
        Bodies = Matter.Bodies,
        Composite = Matter.Composite;

    var engine = Engine.create();

    var render = Render.create({
      element: this.refs.game,
      engine: engine,
      options:{
        height: window.innerHeight,
        width: window.innerWidth,
        wireframes: false,
        showPositions: false
      }
    });

    let player = Bodies.rectangle(
      window.innerWidth * 0.15, // x pos
      window.innerHeight * 0.70,  // y pos
      30, //width
      30, //height,
      { isStatic: false,
        label: 'Player',
        friction: 0,
        render: {
          fillStyle: 'transparent'
        }
      }
      );

    ground1 = Bodies.rectangle(window.innerWidth * 0.3, window.innerHeight * 0.80, window.innerWidth/2, 60, { isStatic: true, label: 'Ground', render: {fillStyle: 'red'}});
    ground2 = Bodies.rectangle(window.innerWidth, window.innerHeight * 0.80, window.innerWidth/2, 60, { isStatic: true, label: 'Ground', render: {fillStyle: 'green'} });
    ground3 = Bodies.rectangle(window.innerWidth * 1.8, window.innerHeight * 0.80, window.innerWidth/2, 60, { isStatic: true, label: 'Ground' , render: {fillStyle: 'blue'}});

    Composite.add(engine.world, [player, ground1, ground2, ground3]);

    Render.run(render);

    var runner = Runner.create();

    Runner.run(runner, engine);

    Events.on(engine, "beforeUpdate", Update)
    

    let PlayerState = {}
    const canvas = document.querySelectorAll("canvas")[1];
    const ctx = canvas.getContext("2d");
    

    let holdCounter = 0;
    let isHoldingJump = false
    let speedVel = 1;
    let maxVel = 5000;
    let acc = 0;
    let maxAcc = 1;
    let distance = 0;
    let groundPos1;
    let groundPos2;
    let groundPos3;
    let isGround1OffScreen = false;
    let isGround2OffScreen = false;
    let isGround3OffScreen = false;
    let prevRndWidthGround1 = 1;
    let prevRndWidthGround2 = 1;
    let prevRndWidthGround3 = 1;
    let rightKeyPress = false;
    let leftKeyPress = false;
    let currentDistance = 0;


    let isReScaled = false
    document.addEventListener("keydown", (e)=>{
      if(e.code === 'Space' || e.code === 'KeyZ' || e.code === 'ArrowUp'){
        if(isGrounded){
          PlayerJump()
        }
        if(e.code === 'Space' || e.code === 'KeyR' || e.code === 'Enter'){
          if (isGameOver){
            RestartGame()
          }
        }
      }
    })

    document.addEventListener("keydown", (e)=>{
      
    })

    document.addEventListener("keyup", (e)=>{
      if(e.code === 'Space' || e.code === 'KeyZ' || e.code === 'ArrowUp'){
        isHoldingJump = false
      }
    })

    document.addEventListener("keydown", (e)=>{
      if(e.code === 'KeyD' || e.code === 'ArrowRight'){
        rightKeyPress = true;
      }
    })
    document.addEventListener("keydown", (e)=>{
      if(e.code === 'KeyQ' || e.code === 'ArrowLeft'){
        leftKeyPress = true;
      }
    })

    document.addEventListener("keyup", (e)=>{
      if(e.code === 'KeyD' || e.code === 'ArrowRight'){
        rightKeyPress = false;
      }
    })
    document.addEventListener("keyup", (e)=>{
      if(e.code === 'KeyQ' || e.code === 'ArrowLeft'){
        leftKeyPress = false;
      }
    })

    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ){//check if mobile
      AddingControlls()
    }

    let noGravity = true
    music.play()
    function Update() {
    if(isGameOver){
      return
    }
    groundPos1 = ground1.position.x;
    groundPos2 = ground2.position.x;
    groundPos3 = ground3.position.x;

    if(isHoldingJump){      
      holdCounter += 1
      let gravity = engine.world.gravity;
      if (noGravity){
        Body.applyForce(player, player.position, {
          x: 0,
          y: -gravity.y * gravity.scale * player.mass
        });
      }
      noGravity = true
      airState = "Ascend"
      if(holdCounter >= 150){
        isHoldingJump = false;
        holdCounter = 0;
      }
    }else{
      noGravity = false
      if (!isGrounded){
        airState = "Descend"
      }
    }

    if(isGrounded){
      let ratio = speedVel / maxVel;
      acc = maxAcc * (1 - ratio)
      speedVel += acc;
      if(speedVel >= maxVel){
        speedVel = maxVel
      }
    }
    distance += speedVel;

    groundPos1 -= (speedVel / 100)
    Body.setPosition(ground1, {x: groundPos1, y: ground1.position.y})
    groundPos2 -= (speedVel / 100)
    Body.setPosition(ground2, {x: groundPos2, y: ground2.position.y})
    groundPos3 -= (speedVel / 100)
    Body.setPosition(ground3, {x: groundPos3, y: ground3.position.y})

    CheckGround1()
    CheckGround2()
    CheckGround3()
    CheckPlayer()
    CheckInput()
    UpdateDistanceCounter()

    }//END UPDATE


    function AddingControlls(){
      let parent = canvas.parentElement

      let jumpButton = document.createElement("div")
      jumpButton.addEventListener("ontouchstart", PlayerJump)
      jumpButton.addEventListener("ontouchend", ()=>{
        isHoldingJump = false
      });

      jumpButton.className = "jumpBtn"
      parent.appendChild(jumpButton)

      let rightArrow = document.createElement("div")
      rightArrow.addEventListener("ontouchstart", ()=>{
        rightKeyPress = true
      })
      rightArrow.addEventListener("ontouchend", ()=>{
        rightKeyPress = false
      });

      rightArrow.className = "touchArrow rightArrow"
      parent.appendChild(rightArrow)

      let leftArrow = document.createElement("div")
      leftArrow.addEventListener("ontouchstart", ()=>{
        leftKeyPress = true
      })
      leftArrow.addEventListener("ontouchend", ()=>{
        leftKeyPress = false
      });

      leftArrow.className = "touchArrow leftArrow"
      parent.appendChild(leftArrow)
    }


    function UpdateDistanceCounter(){
      currentDistance = Math.floor(distance / 10000)
      ctx.font = "50px Source Code Pro";
      ctx.fillStyle = "red"
      ctx.fillText(currentDistance + 'm', window.innerWidth - 200, 100)
    }

    function CheckInput(){
      if(rightKeyPress){
        Body.applyForce(player, player.position, {x: 0.0002, y: 0})
      }
      if(leftKeyPress){
        Body.applyForce(player, player.position, {x: -0.0002, y: 0})
      }
    }
    function CheckPlayer(){
      if(player.position.y > window.innerHeight){
        GameOver()
      }
    }

    function PlayerJump(){
      isHoldingJump = true
      Body.applyForce(player, player.position, {x: 0, y: -0.02})
      isGrounded = false
      holdCounter = 0
    }


    function CheckGround1(){
      let {min, max} = ground1.bounds
      let groundW1 = max.x - min.x
      isGround1OffScreen = ((ground1.position.x + (groundW1 / 2) ) < 0)
      if(isGround1OffScreen){
        RespawnGround1();
      }
    }

    function CheckGround2(){
      let {min, max}  = ground2.bounds
      let groundW2 = max.x - min.x
      isGround2OffScreen = ((ground2.position.x + (groundW2 / 2) ) < 0)
      if(isGround2OffScreen){
        RespawnGround2()
      }
    }

    function CheckGround3(){
      let {min, max} = ground3.bounds
      let groundW3 = max.x - min.x
      isGround3OffScreen = ((ground3.position.x + (groundW3 / 2) ) < 0)
      if(isGround3OffScreen){
        RespawnGround3()
      }
    }


    function mapRange(val, in_min, in_max, out_min, out_max){
       return (val - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
        // return out_min + ((val - in_min) * (out_max - out_min)) / (in_max - in_min)
    }

    function RespawnGround1(){//RED

      if (!isReScaled){
        let maxScale = 1.5
        let minScale = 0.4
        let RndWith = (Math.random() * (maxScale - minScale) + minScale)
        RndWith = Math.round(RndWith* 10)  / 10
  
        // RndWith = (RndWith + mapRange(currentDistance, 0, 1500, minScale, maxScale) / 5)
        Body.scale(ground1, 1 / prevRndWidthGround1 , 1)
        prevRndWidthGround1 = RndWith;
        Body.scale(ground1, RndWith, 1)
        console.log(RndWith)
        isReScaled = true
      }
      let RndY = (Math.floor(Math.random() * 5 + 1) / 10) + 0.4
      let RndX;
      
      let ground1Width = GetGroundWidth(ground1);
      let ground3Width = GetGroundWidth(ground3);

      let minDistance = (ground1Width ) + (ground3Width );

      RndX = window.innerWidth + minDistance;
      // console.log(RndX + "min distance: " + (ground3.position.x + (ground3Width / 2) + (minDistance / 2)))
      // console.log(RndX > (ground3.position.x + (minDistance / 2)))
      if (RndX > (ground3.position.x + (ground3Width / 2) + (minDistance / 2))){
        Body.setPosition(ground1, {x: RndX, y: window.innerHeight * RndY})
        isReScaled = false
      }
    }

    function RespawnGround2(){//GREEN

      if (!isReScaled){
        let maxScale = 1.5
        let minScale = 0.4
        let RndWith = (Math.random() * (maxScale - minScale) + minScale)
        
        RndWith = Math.round((RndWith + mapRange(currentDistance, 0, 1500, minScale, maxScale) / 5) * 10) / 10 
        Body.scale(ground2, 1 / prevRndWidthGround2 , 1)
        prevRndWidthGround2 = RndWith;
        Body.scale(ground2, RndWith, 1)

        isReScaled = true
      }

      let RndY = (Math.floor(Math.random() * 5 + 1) / 10) + 0.4
      let RndX


      let ground2Width = GetGroundWidth(ground2);
      let ground1Width = GetGroundWidth(ground1);

      let minDistance = ground2Width + ground1Width;
      RndX = window.innerWidth + minDistance
      
      if (RndX > ground1.position.x + (ground1Width / 2) + (minDistance / 2)){
        Body.setPosition(ground2, {x: RndX, y: window.innerHeight * RndY})
        isReScaled = false
      }
    }

    function RespawnGround3(){//BLUE

      if (!isReScaled){
        let maxScale = 1.5
        let minScale = 0.4
        let RndWith = (Math.random() * (maxScale - minScale) + minScale)
        // RndWith = Math.round(RndWith* 10)  / 10
        RndWith = Math.round((RndWith + mapRange(currentDistance, 0, 1500, minScale, maxScale) / 5) * 10) / 10 
        Body.scale(ground3, 1 / prevRndWidthGround3 , 1)
        prevRndWidthGround3 = RndWith;
        Body.scale(ground3, RndWith, 1)
        isReScaled = false
      }

      let RndY = (Math.floor(Math.random() * 5 + 1) / 10) + 0.4
      let RndX
    

      let ground3Width = GetGroundWidth(ground3);
      let ground2Width = GetGroundWidth(ground2);

      let minDistance = ground3Width + ground2Width;
      RndX = window.innerWidth + minDistance

      if (RndX > ground2.position.x + (ground2Width / 2) + (minDistance / 2)){
      Body.setPosition(ground3, {x: RndX, y: window.innerHeight * RndY})
      isReScaled = false
      }
    }

    function GetGroundWidth(ground){
      let {min, max}  = ground.bounds
      return max.x - min.x
    }

    function GameOver(){
      music.pause()
      music = new Audio(deathSound)
      music.volume = 0.7;
      music.play()
      
      isGameOver = true
      let parent = canvas.parentElement
      
      let gameOverContainer = document.createElement("div")
      gameOverContainer.className = "gameOver"
      
      let textScoreSpan = document.createElement("span")
      textScoreSpan.innerHTML = "Score: " + currentDistance + "m"
      textScoreSpan.className = "score"
      
      let textP = document.createElement("p")
      textP.innerHTML = "Git Gud"
      
      let highScoreSpan = document.createElement("span")
      GetHighScore().then(res =>{
        highScoreSpan.innerHTML = "Highscore: " + res + "m"
        if (currentDistance > res){
          textP.innerHTML = "New Highscore!"
          highScoreSpan.innerHTML = "Previous Highscore: " + res + "m"
          SetHighScore(currentDistance)
          localStorage.setItem("HighScore", currentDistance)
        }
      })

      let retrySpan = document.createElement("span")
      retrySpan.innerHTML = "Press spacebar to retry"
      retrySpan.className = "highscore"


      highScoreSpan.className = "highscore"
      let btnContainer = document.createElement("div")

      let retryBtn = document.createElement("button")
      retryBtn.innerHTML = "Retry"

      let backBtn=  document.createElement("button")
      backBtn.innerHTML = "Back"

      backBtn.onclick = () =>{
        window.location.pathname = "/menu"
      }

      retryBtn.onclick = RestartGame


      btnContainer.appendChild(backBtn)
      btnContainer.appendChild(retryBtn)

      gameOverContainer.appendChild(textP)
      gameOverContainer.appendChild(textScoreSpan)
      gameOverContainer.appendChild(highScoreSpan)
      gameOverContainer.appendChild(retrySpan)
      gameOverContainer.appendChild(btnContainer)
      parent.appendChild(gameOverContainer)
    }

    function RestartGame(){
      music = new Audio(musicFile)
      music.volume = 0.3
      music.play()

      isGameOver = false

      prevRndWidthGround1 = 1;
      prevRndWidthGround2 = 1;
      prevRndWidthGround3 = 1;
      document.querySelector('.gameOver').remove()

      Composite.remove(engine.world, [ground1, ground2, ground3])
      ground1 = Bodies.rectangle(window.innerWidth * 0.3, window.innerHeight * 0.80, window.innerWidth/2, 60, { isStatic: true, label: 'Ground', render: {fillStyle: 'red'}});
      ground2 = Bodies.rectangle(window.innerWidth, window.innerHeight * 0.80, window.innerWidth/2, 60, { isStatic: true, label: 'Ground', render: {fillStyle: 'green'} });
      ground3 = Bodies.rectangle(window.innerWidth * 1.8, window.innerHeight * 0.80, window.innerWidth/2, 60, { isStatic: true, label: 'Ground' , render: {fillStyle: 'blue'}});
      
      Composite.add(engine.world, [ground1, ground2, ground3])

      speedVel = 1;
      maxVel = 5000;
      acc = 0;
      maxAcc = 1;
      distance = 0;
      currentDistance = 0;
      
      isReScaled = false
      
      Body.setPosition(player, {x: window.innerWidth * 0.15, y: window.innerHeight * 0.15})
    }

    Events.on(engine, 'collisionStart', function(event) {
      var pairs = event.pairs[0];
      if(pairs.bodyA.label === 'Player' && pairs.bodyB.label === 'Ground'){
        isGrounded = true;
        airState = "ground"
      }
    });

    Events.on(engine, 'collisionEnd', function(event) {
      var pairs = event.pairs[0];
      if(pairs.bodyA.label === 'Player' && pairs.bodyB.label === 'Ground'){
        isGrounded = false;
      }
    });
    
    animate(PlayerState, player, ctx)
    bacgrkoundparallax(ctx)
  }

  componentWillUnmount(){
    document.querySelector('nav').style.display = 'flex'
  }
  render(){
    return <div ref='game'/>
  }
}

export { airState, isGrounded, gameSpeed, ground1, ground2, ground3 }

export default Game